import { useState, useEffect } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import { Select, MenuItem, Input } from "@material-ui/core";
const dropdownOptions = [
  { id: 0, value: "Jan" },
  { id: 1, value: "Feb" },
  { id: 2, value: "Mar" },
  { id: 3, value: "Apr" },
  { id: 4, value: "May" },
  { id: 5, value: "Jun" },
  { id: 6, value: "Jul" },
  { id: 7, value: "Aug" },
  { id: 8, value: "Sep" },
  { id: 9, value: "Oct" },
  { id: 10, value: "Nov" },
  { id: 11, value: "Dec" },
];

const FiscalYearComponent = (props) => {
  const { inputValue, handleCustomSubmit, cell } = props;
  const { id } = cell.column.columnDef;
  // Initial Value setup
  const today = new Date();
  const initialValue = {
    from_month: dropdownOptions.find((el) => el.id === today.getMonth()),
    to_month: dropdownOptions.find((el) => el.id === today.getMonth()),
  };
  const [dateValue, setDateValue] = useState(initialValue);

  // Setting the input value
  useEffect(() => {
    let fromDateString = inputValue?.from_month;
    let toDateString = inputValue?.to_month;

    if (fromDateString && toDateString) {
      if (fromDateString?.length < 11 || toDateString?.length < 11) {
        fromDateString = moment(fromDateString, "DD-MM-YYYY").toISOString();
        toDateString = moment(toDateString, "DD-MM-YYYY").toISOString();
      }
      setDateValue({
        from_month: dropdownOptions.find(
          (el) => el.id === new Date(fromDateString).getMonth()
        ),
        to_month: dropdownOptions.find(
          (el) => el.id === new Date(toDateString).getMonth()
        ),
      });
    }
  }, [inputValue]);

  console.log(dateValue, "dateValue");
  const pickerProps = {
    InputProps: {
      readOnly: true,
      style: {
        fontSize: "12px",
      },
    },
    helperText: "",
    size: "small",
    format: "MMM",
    fullWidth: true,
    disableToolbar: true,
    views: ["month"],
  };
  const handleMonthChange = (key, value) => {
    setDateValue((prev) => {
      const newValues = {
        ...prev,
        [key]: dropdownOptions.find((el) => el.id === value),
      };
      const valuesTobeSent = {
        from_month: new Date(2023, newValues.from_month.id, 1).toISOString(),
        to_month: new Date(2023, newValues.to_month.id, 1).toISOString(),
      };
      handleCustomSubmit(id, valuesTobeSent);
      return newValues;
    });
  };

  return (
    <div style={{ width: "100%", display: "flex", alignItems: "flex-end" }}>
      <div style={{ width: "40%" }}>
        {/* <KeyboardDatePicker
          placeholder="From"
          value={dateValue?.from_month}
          defaultValue={dateValue?.from_month}
          onChange={(val) => {
            handleInputChange("from_month", val);
          }}
          variant="inline"
          {...pickerProps}
        /> */}
        <Select
          value={dateValue.from_month}
          defaultValue={dateValue.from_month}
          onChange={(event) => {
            handleMonthChange("from_month", event.target.value);
          }}
          id={id + "_select"}
          fullWidth
          key={id + "_select"}
          Input={<Input style={{ fontSize: "12px" }} />}
          renderValue={(o) => {
            console.log(o, "renderValue");
            return <div style={{ fontSize: "12px" }}> {o?.value} </div>;
          }}
        >
          {dropdownOptions?.map((option) => (
            <MenuItem
              key={option?.value}
              style={{ fontSize: "12px" }}
              value={option?.id}
            >
              {option?.value}
            </MenuItem>
          ))}
        </Select>
      </div>
      <p
        style={{
          width: "20%",
          textAlign: "center",
          fontWeight: "bold",
          margin: 0,
        }}
      >
        to
      </p>
      <div style={{ width: "40%" }}>
        <Select
          value={dateValue.to_month}
          defaultValue={dateValue.to_month}
          onChange={(event) => {
            handleMonthChange("to_month", event.target.value);
          }}
          id={id + "_select"}
          fullWidth
          key={id + "_select"}
          Input={<Input style={{ fontSize: "12px" }} />}
          renderValue={(o) => {
            console.log(o, "renderValue");
            return <div style={{ fontSize: "12px" }}> {o?.value} </div>;
          }}
        >
          {dropdownOptions?.map((option) => (
            <MenuItem
              key={option?.value}
              style={{ fontSize: "12px" }}
              value={option?.id}
            >
              {option?.value}
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
};
export default FiscalYearComponent;
